import StyledLinkButton from "features/shared/components/buttons/link-button/styles/StyledLinkButton.styled";
import styled from "styled-components";
import PrimaryButton from "features/shared/components/buttons/PrimaryButton.styled";
import Separator from "features/shared/styles/separator/Separator.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import Body from "features/shared/styles/typography/Body.styled";

const StyledPassengerConsent = styled.div`
  ${StyledLinkButton} {
    margin-top: 32px;
  }
  ${MicroHeader}, ${Separator} {
    margin: 16px 0;
  }

  ${Body} {
    margin-bottom: 16px;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    ${PrimaryButton} {
      width: 100%;
    }
  }
`;

export default StyledPassengerConsent;
